import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ImageCaptureMode } from '@main-application/inspections/models/rest-inspections-model.interface';
import { EColorPalette } from '@shared/enums/color-palette.enum';
import { EIcon } from '@shared/enums/icon.enum';
import { IconComponent } from '@ui-components/components/icon/icon.component';

import { TemplateEditorDialogAnimationComponent } from '../../template-editor-dialog/template-editor-area/template-editor-item/rating-group/animation/template-editor-animation.component';

@Component({
  selector: 'app-cost-file-ticket-parts-setup-placeholder',
  templateUrl: './cost-file-ticket-parts-setup-placeholder.component.html',
  styleUrls: ['./cost-file-ticket-parts-setup-placeholder.component.scss'],
  standalone: true,
  imports: [CommonModule, IconComponent, TemplateEditorDialogAnimationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostFileTicketPartsSetupPlaceholderComponent {
  @Input() showRate = true;
  @Input() showPhotos = true;
  @Input() showComment = true;
  @Input() showDone = true;

  @Input() rateRequired = false;
  @Input() photosRequired = false;
  @Input() commentRequired = false;

  @Input() captureMode: ImageCaptureMode = ImageCaptureMode.PhotoAndGallery;

  readonly EIcon = EIcon;
  readonly EColorPalette = EColorPalette;
  readonly ImageCaptureMode = ImageCaptureMode;

  get photosLabel(): string {
    if (this.captureMode === ImageCaptureMode.AnyFile) {
      return 'Add photos & documents';
    }
    return 'Add photos';
  }

  get photosIcon(): EIcon {
    return this.captureMode === ImageCaptureMode.AnyFile ? EIcon.CLOUD_UPLOAD : EIcon.PHOTO_CAMERA;
  }
}
